export enum AllowedProvidersUrl {
  YOUTUBE = 'https://www.youtube.com/oembed',
  SPOTIFY = 'https://open.spotify.com/oembed',
}

// handles only youtube and spotify for now
export function findOembedProviderUrl(url: string | undefined): string | undefined {
  if (!url) {
    return undefined;
  }
  if (url.includes('spotify')) {
    return AllowedProvidersUrl.SPOTIFY;
  }
  if (url.includes('youtu')) {
    return AllowedProvidersUrl.YOUTUBE;
  }
  throw new Error('Unsupported provider');
}

export function isValidProvider(targetUrl: string): boolean {
  const providerUrl = findOembedProviderUrl(targetUrl);
  if (!providerUrl) {
    return false;
  }
  return (Object.values(AllowedProvidersUrl) as string[]).includes(providerUrl);
}
